import React from 'react';
import {
  useFieldArrayMethods,
  useFormMethods,
} from '../../../../../../helpers/formManager';
import OptionButton from '../../../../shared/ui/OptionButton';
import { useDurationAndTimeConfig } from '../../providers/durationAndTimeProvider';
import { useSelectedIdsActions } from '../../providers/selectedIdsProvider';

const RemoveInterval = ({ index, disabled }) => {
  if (disabled) {
    return <div style={{ width: '22px', height: '22px' }} />;
  }

  return <Action index={index} />;
};

export default RemoveInterval;

function Action({ index }) {
  const { remove } = useFieldArrayMethods();

  const { createIntervalIdName } = useDurationAndTimeConfig();
  const intervalName = createIntervalIdName(index);

  const { getValues } = useFormMethods();

  const { deleteId } = useSelectedIdsActions();

  const handleClick = () => {
    const interval = getValues(intervalName);

    if (interval) {
      deleteId(interval.context.id);
    }

    remove(index);
  };

  return (
    <OptionButton
      type={OptionButton.types.danger}
      icon="delete"
      tooltipTitle="Удалить интервал"
      onClick={handleClick}
    />
  );
}
